import { KeyValuePairArray } from "app/models/KeyValuePair";

export enum MemberTypes {

    Member = 0,
    Designer = 1

}

export interface ILoginResponse {

    Token: string;
    Authenticated: boolean;
    TokenExpiration: Date;
    TwoFactorRequired: boolean;
    TwoFactorOptions: KeyValuePairArray<string, string>;
    TwoFactorExpiration: Date;
    Redirect: string;
    FirstName: string;
    LastName: string;
    MemberID: number;
    Username: string;
    Email: string;
    MemberType: MemberTypes;
    UnfinishedOrderID: string;
    IsFormerTOS: boolean;
    IsTOS: boolean;
    IsDispute: boolean;
    // FixDates();

}

export class LoginResponse implements ILoginResponse {

    Token: string = "";
    Authenticated: boolean = false;
    TokenExpiration: Date;
    TwoFactorRequired: boolean = false;
    TwoFactorOptions: KeyValuePairArray<string, string>;
    TwoFactorExpiration: Date;
    Redirect: string;
    FirstName: string;
    LastName: string;
    MemberID: number;
    Username: string;
    Email: string;
    MemberType: MemberTypes;
    UnfinishedOrderID: string;
    IsFormerTOS: boolean;
    IsTOS: boolean;
    IsDispute: boolean;


    // FixDates() {

    //     this.TokenExpiration = new Date(this.TokenExpiration);

    //     if (this.TwoFactorRequired)
    //         this.TwoFactorExpiration = new Date(this.TwoFactorExpiration);
    // }

}